import "./HikesAndSounds.module.css";
import Header from "@/reusable_sections/Header";
import TheJournal from "./sections/TheJournal";
import Footer from "@/reusable_sections/Footer";
import TravelHeader from "./sections/TravelHeader";
import DonationMemorial from "./sections/DonationMemorial";
export default function HikesAndSoundsPage() {
  return <div>
      <Header />
      <TravelHeader />
      <TheJournal />
      <DonationMemorial />
      <Footer />
    </div>;
}